module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_kimono-5731283e823b49c6e00aecfec39d230d.webp";